import React, { useState, useEffect } from 'react';
import axios from 'axios';
import params from '../config/Params';
import { getItemFromLocalStorage } from '../utils/storageUtils';
import { Helmet } from 'react-helmet';
import { useParams } from 'react-router-dom';

const GuestDetails = () => {
    const { bookingId, categoryId } = useParams();
    const [filteredBooking, setFilteredBooking] = useState(null);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    
    useEffect(() => {
        const fetchBookingDetails = async () => {
            setLoading(true);
            const hostData = getItemFromLocalStorage('hostProfile');
            let formData = new FormData();
            formData.append('token', hostData.host_access_token);
            formData.append('category', categoryId);
    
            try {
                const response = await axios({
                    method: 'post',
                    headers: {
                        'Content-Type': 'multipart/form-data'
                    },
                    url: `${params.baseURL}${params.endpoints.getMyBooking}`,
                    data: formData
                });
    
                if (response.data && response.data.items.length > 0) {
                    const booking = response.data.items.find(
                        (item) => item.stay_booking_id === Number(bookingId)
                    );
                    setFilteredBooking(booking || null);
                } else {
                    setError('No booking data found for this category.');
                }
            } catch (err) {
                setError('An error occurred while fetching booking data.');
            } finally {
                setLoading(false);
            }
        };

        fetchBookingDetails();
    }, [categoryId, bookingId]);

    if (loading) {
        return <p>Loading...</p>;
    }

    if (error) {
        return <p>No booking found for the provided ID.</p>;
    }

    return (
        <div>
            <Helmet>
                <title>Guest Details</title>
                <meta name="description" content="" />
            </Helmet>

            <div className='booking-detail-section'>
                {filteredBooking && (
                    <>
                        <div className='gdptb'>
                            <span>About Guest</span>
                        </div>
                        <div className='category-img-section guest-image-section'>
                            <div className='gdpimgb'>
                                <img src={filteredBooking.guest_profile_image} alt='' className='img-fluid' />
                            </div>
                        </div>

                        <div class="guest-detail-section">
                            <div class="rating-info">
                                {filteredBooking.guest_pet_details?.data ? (
                                <div className="ri-box">
                                    <img src={filteredBooking.guest_pet_details.img} className="img-fluid" />
                                    <div className="ri-content-box">
                                    <span>{filteredBooking.guest_pet_details.data}</span>
                                    </div>
                                </div>
                                ) : (
                                <div className="ri-box">
                                    <img src={filteredBooking.guest_since.img} className="img-fluid" />
                                    <div className="ri-content-box">
                                    <span>{filteredBooking.guest_since.data}</span>
                                    </div>
                                </div>
                                )}
                                <div class="ri-box">
                                    <img src={filteredBooking.guest_average_rating.img} class="img-fluid" />
                                    <span class="ri-content-box">
                                        <span>{filteredBooking.guest_average_rating.data}</span>
                                    </span>
                                </div>
                                <div class="ri-box">
                                    <img src={filteredBooking.guest_review_count.img} class="img-fluid" />
                                    <span class="ri-content-box">
                                        <span>{filteredBooking.guest_review_count.data}</span>
                                    </span>
                                </div>
                            </div>
                        </div>

                        <div>
                            <div className='gds-box'>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/user_since_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.customer_name}</p>
                                </div>
                                {/*<span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/whatsapp_icon_r.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.customer_phone}</p>
                                </div>*/}
                                {filteredBooking.guest_pet_details?.data && (
                                <>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/user_since_icon.svg'} alt="" className="bd-icon" />
                                    <p>{filteredBooking.guest_since.data}</p>
                                </div>
                                </>
                                )}
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/workplace_icon.svg'} alt="" className="bd-icon" />
                                    <p>My work: {filteredBooking.guest_workplace}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/music_icon.svg'} alt="" className="bd-icon" />
                                    <p>Favourite song in high school: {filteredBooking.guest_fav_song}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/live_location_icon.svg'} alt="" className="bd-icon" />
                                    <p>Lives in {filteredBooking.guest_living_location}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/school_icon.svg'} alt="" className="bd-icon" />
                                    <p>Where i went to school: {filteredBooking.guest_school_name}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/obsessed_icon.svg'} alt="" className="bd-icon" />
                                    <p>I'm obsessed with: {filteredBooking.guest_obsessed}</p>
                                </div>
                                <span className="line"></span>
                                <div className='gds-sub-box'>
                                    <img src={'/assets/img/icons/birhtday_icon.svg'} alt="" className="bd-icon" />
                                    <p>Born in the {filteredBooking.guest_born_decade}</p>
                                </div>
                            </div>
                        </div>
                    </>
                )}
            </div>

        </div>
    );
};

export default GuestDetails;
